module.exports = __webpack_public_path__ + "img/pro_two_9.1906cd97.jpg";